<template>
  <div class="fixed inset-0">
    <div class="absolute top-3 left-3 z-50">
      <div class="bg-white rounded-sm px-3 py-2 hover:bg-gray-100 cursor-pointer" @click="closeMap">
        <close-icon :width="'w-4'" :height="'h-4'"></close-icon>
      </div>
    </div>
    <div id="map2" class="w-full h-full"></div>
  </div>
</template>

<script>
import CloseIcon from '../icons/CloseIcon.vue'
export default {
  components: { CloseIcon },
  props: {
    from: String,
    to: String,
    coordinates: Object
  },
  methods: {
    async initMap() {
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(document.getElementById('map2'), {
        zoom: 14,
        center: { lat: this.coordinates.lat, lng: this.coordinates.lng },
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false
      })

      await this.calculateAndDisplayRoute(map)
    },

    async calculateAndDisplayRoute(map) {
      try {
        // eslint-disable-next-line no-undef
        const { Route } = await google.maps.importLibrary('routes')

        const { routes } = await Route.computeRoutes({
          origin: this.from,
          destination: this.to,
          travelMode: 'DRIVING',
          fields: ['path']
        })

        if (!routes || !routes.length) {
          window.alert('No route found')
          return
        }

        const polylines = routes[0].createPolylines()

        if (Array.isArray(polylines)) {
          polylines.forEach(polyline => {
            if (polyline && typeof polyline.setMap === 'function') {
              polyline.setMap(map)
            }
          })
        } else if (polylines && typeof polylines.setMap === 'function') {
          polylines.setMap(map)
        }

        this.routePolylines = polylines
      } catch (error) {
        console.error('Directions request failed:', error)
        window.alert('Directions request failed')
      }
    },

    closeMap() {
      this.$emit('open-map', false)
    }
  },
  mounted() {
    this.initMap()
  }
}
</script>

<style></style>
